import { QdsNativeTemporalField } from '../shared/native-temporal-field.js';

/**
 * Local date and wall-clock time using a native editor; canonical strings have no UTC offset.
 * @element qds-date-time-picker
 * @attr {string} value - Canonical default/reset value; property value is current.
 * @attr {string} min - Inclusive canonical lower bound; malformed bounds ignored.
 * @attr {string} max - Inclusive canonical upper bound; malformed bounds ignored.
 * @attr {number|'any'} step - Seconds increment; default60, positive fractions or any.
 * @attr {string} locale - Intl summary locale; native editing follows browser/OS settings.
 * @attr {string} label - Visible label.
 * @attr {string} aria-label - Explicit accessible name.
 * @attr {string} aria-labelledby - External naming text IDs.
 * @attr {string} hint - Helper text, including application-owned zone context.
 * @attr {string} error-text - Validation message override.
 * @attr {string} name - Native submission key.
 * @attr {string} form - External native form ID.
 * @attr {boolean} required - Requires a complete value.
 * @attr {boolean} readonly - Submitted and focusable, without user edits.
 * @attr {boolean} disabled - Not interactive or submitted.
 * @attr {boolean} invalid - Application-owned invalid state.
 * @attr {'input'|'blur'|'submit'} validate-on - Feedback timing; default blur.
 * @attr {'sm'|'md'|'lg'} size - Field size; native editor remains at least44px.
 * @property {string} value - Current canonical local string or empty; silent owner writes.
 * @property {string} defaultValue - Attribute-backed canonical reset value.
 * @property {string} formattedValue - Read-only localized summary; no model conversion.
 * @csspart container - Field container.
 * @csspart label - Native input label.
 * @csspart input - Stable native editor.
 * @csspart value - Localized presentation.
 * @csspart hint - Helper text.
 * @csspart error - Constraint feedback.
 * @fires {{component:HTMLElement;value:string}} input - Native user edit, once.
 * @fires {{component:HTMLElement;value:string}} change - Native committed edit, once.
 * @fires {{component:HTMLElement;valid:boolean;validity:{valid:boolean;valueMissing:boolean;tooShort:boolean;tooLong:boolean;customError:boolean;badInput:boolean;rangeUnderflow:boolean;rangeOverflow:boolean;stepMismatch:boolean};message:string}} qds-validity-change - Validity/message transition.
 */
export class QdsDateTimePicker extends QdsNativeTemporalField {
  protected readonly _inputType = 'datetime-local' as const;
}
if (!customElements.get('qds-date-time-picker')) customElements.define('qds-date-time-picker', QdsDateTimePicker);
